<template>
  <!-- Desktop Sidebar Navigation -->
  <div class="tenant-nav desktop-nav" :class="{ collapsed: !$store.state.showTenantNav }">
    <div class="tenant-nav-content">
      <div class="tenant-nav-content-header">
        <label v-if="$store.state.showTenantNav">Centenary house</label>
        <button class="nav-toggle-btn" @click="$toggleTenantNav()">
          <i
            class="fas fa-angle-left"
            :class="{ rotate: !$store.state.showTenantNav }"
          ></i>
        </button>
      </div>
      <div class="tenant-nav-content-inner">
        <div class="tenant-nav-content-inner-item">
          <router-link :to="{ name: 'TenantDashboard' }"
            ><i class="fa fa-tachometer"></i> <span v-if="$store.state.showTenantNav">Dashboard</span></router-link
          >
        </div>
        <div class="tenant-nav-content-inner-item">
          <router-link :to="{ name: 'TenantBills' }"
            ><i class="fa-solid fa-money-bill-1-wave"></i> <span v-if="$store.state.showTenantNav">Invoices</span></router-link
          >
        </div>
        <div class="tenant-nav-content-inner-item">
          <router-link :to="{ name: 'TenantSubscriptions' }"
            ><i class="fa fa-credit-card"></i> <span v-if="$store.state.showTenantNav">Subcriptions</span></router-link
          >
        </div>
        <!-- <div class="tenant-nav-content-inner-item">
          <router-link :to="{ name: 'TenantMessages' }"
            ><i class="fa fa-envelope"></i> Messages
            <Tag color="#e96767" v-if="unread > 0">{{
              unread
            }}</Tag></router-link
          >
        </div> -->
        <!-- <div class="tenant-nav-content-inner-item">
          <router-link :to="{ name: 'TenantPosts' }"
            ><i class="fa fa-bell"></i> Posts</router-link
          >
        </div> -->
        <!-- <div class="tenant-nav-content-inner-item">
          <router-link :to="{ name: 'Home' }"
            ><i class="fa fa-exclamation-triangle"></i> Complaints</router-link
          >
        </div> -->
        <div class="tenant-nav-content-inner-item">
          <router-link :to="{ name: 'TenantCancellationRequests' }"
            ><i class="fa fa-ban"></i> <span v-if="$store.state.showTenantNav">Cancellations</span></router-link
          >
        </div>
        <div class="tenant-nav-content-inner-item">
          <router-link :to="{ name: 'TenantSettings' }"
            ><i class="fa fa-cog"></i> <span v-if="$store.state.showTenantNav">Settings</span></router-link
          >
        </div>
        <div class="tenant-nav-content-inner-item">
          <a href="#" @click="$tenantLogout"
            ><i class="fa fa-sign-out"></i> <span v-if="$store.state.showTenantNav">Logout</span></a
          >
        </div>
      </div>
    </div>
  </div>

  <!-- Mobile Bottom Navigation -->
  <div class="tenant-nav-mobile mobile-nav">
    <div class="mobile-nav-item">
      <router-link :to="{ name: 'TenantDashboard' }">
        <i class="fa fa-tachometer"></i>
        <span>Dashboard</span>
      </router-link>
    </div>
    <div class="mobile-nav-item">
      <router-link :to="{ name: 'TenantSubscriptions' }">
        <i class="fa fa-credit-card"></i>
        <span>Subscriptions</span>
      </router-link>
    </div>
    <div class="mobile-nav-item">
      <router-link :to="{ name: 'TenantBills' }">
        <i class="fa-solid fa-money-bill-1-wave"></i>
        <span>Invoices</span>
      </router-link>
    </div>
    <div class="mobile-nav-item">
      <router-link :to="{ name: 'TenantCancellationRequests' }">
        <i class="fa fa-ban"></i>
        <span>Cancellations</span>
      </router-link>
    </div>
    <div class="mobile-nav-item">
      <router-link :to="{ name: 'TenantSettings' }">
        <i class="fa fa-cog"></i>
        <span>Settings</span>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    if (!this.$getTenant()) {
      this.$tenantLogout();
    }
    // Load collapsed state from localStorage
    const savedState = localStorage.getItem("showTenantNav");
    if (savedState !== null) {
      this.$store.state.showTenantNav = savedState === "true";
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/main.scss";
.tenant-nav {
  background: #fff;
  border-radius: 10px;
  // box-shadow: -10px 0 10px rgba(63, 63, 63, 0.1);
  height: 85vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transition: width 0.3s ease;
  width: 250px;
  
  &.collapsed {
    width: 70px;
  }
  
  .tenant-nav-content {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
    .tenant-nav-content-header {
      padding: 1rem;
      border-bottom: 2px solid #7e82af;
      flex-shrink: 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: relative;
      
      label {
        font-size: 0.8rem;
        font-weight: 600;
        text-transform: uppercase;
        transition: opacity 0.3s ease;
        white-space: nowrap;
        overflow: hidden;
      }
      
      .nav-toggle-btn {
        background: transparent;
        border: none;
        cursor: pointer;
        padding: 0.25rem;
        display: flex;
        align-items: center;
        justify-content: center;
        color: $primary_color;
        transition: transform 0.3s ease;
        
        i {
          font-size: 1rem;
          transition: transform 0.3s ease;
          
          &.rotate {
            transform: rotate(180deg);
          }
        }
        
        &:hover {
          opacity: 0.7;
        }
      }
    }
    .tenant-nav-content-inner {
      display: flex;
      flex-direction: column;
      flex: 1;
      overflow-y: auto;
      overflow-x: hidden;
      -webkit-overflow-scrolling: touch;
      .tenant-nav-content-inner-item {
        a {
          padding: 1rem 1rem;
          border-bottom: 1px solid #f3f3f3;
          display: flex;
          align-items: center;
          gap: 0.75rem;
          color: #000;
          font-size: 0.9rem;
          transition: all 0.3s ease;
          font-weight: 500;
          white-space: nowrap;
          
          i {
            font-size: 1rem;
            min-width: 20px;
            text-align: center;
          }
          
          span {
            transition: opacity 0.3s ease;
            overflow: hidden;
          }
          
          &:hover {
            background: #7e82af73;
          }
        }
        .router-link-active {
          background: #a8ade65e;
          color: $primary_color;
        }
      }
    }
  }
  
  &.collapsed {
    .tenant-nav-content-header {
      label {
        opacity: 0;
        width: 0;
        overflow: hidden;
      }
    }
    
    .tenant-nav-content-inner-item {
      a {
        justify-content: center;
        padding: 1rem 0.5rem;
        
        span {
          opacity: 0;
          width: 0;
          overflow: hidden;
        }
      }
    }
  }
  
  // Mobile styles - hide desktop nav
  @media (max-width: 768px) {
    display: none;
  }
}

// Mobile Bottom Navigation
.tenant-nav-mobile {
  display: none;
  
  @media (max-width: 768px) {
    display: flex;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: #fff;
    border-top: 2px solid #7e82af;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
    z-index: 1000;
    justify-content: space-around;
    align-items: center;
    padding: 0.5rem 0;
    height: 70px;
    
    .mobile-nav-item {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      
      a {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 0.25rem;
        padding: 0.5rem;
        color: #666;
        text-decoration: none;
        transition: all 0.3s ease;
        width: 100%;
        height: 100%;
        
        i {
          font-size: 1.25rem;
          color: #666;
          transition: color 0.3s ease;
        }
        
        span {
          font-size: 0.7rem;
          font-weight: 500;
          color: #666;
          transition: color 0.3s ease;
        }
        
        &:hover,
        &.router-link-active {
          color: $primary_color;
          
          i {
            color: $primary_color;
          }
          
          span {
            color: $primary_color;
          }
        }
      }
    }
  }
}
</style>
